import { styled } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import { useAttorneyHubDispatch } from "_shared/_stores/redux-store";
import { 
  getErrorLoadingTeamAvatar, 
  getIsLoadingTeamAvatar, 
  getTeamAvatar, 
  populateMarketplaceTeamAvatar 
} from "marketplace/teams/_store/marketplace-teams-redux-slice";
import Team from "marketplace/teams/team";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Session from "users/__session/session";

const StyledAvatar = styled(Avatar)<{ disabled?: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
}));
const LoadingProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700],
  height: "75%",
  width: "75%",
}));

type TeamAvatarProps = {
  className?: string;
  team?: Team;
  disabled?: boolean;
  session: Session;
};

export default function TeamAvatar(props: Readonly<TeamAvatarProps>) {
  const {
    className,
    team,
    disabled,
    session
  } = props;

  const dispatch = useAttorneyHubDispatch();

  const base64AvatarData = useSelector(getTeamAvatar(team?.id ?? null));
  const isLoadingAvatar = useSelector(getIsLoadingTeamAvatar(team?.id ?? null));
  const errorLoadingAvatar = useSelector(getErrorLoadingTeamAvatar(team?.id ?? null));

  useEffect(() => {
    if (!team?.profile.avatarId || base64AvatarData || isLoadingAvatar || errorLoadingAvatar) return;

    const abortController = new AbortController();
    dispatch(populateMarketplaceTeamAvatar({ session, teamId: team.id, abortController }));
  }, [
    dispatch,
    session,
    team?.profile.avatarId?.value,
    isLoadingAvatar,
    errorLoadingAvatar,
    !!base64AvatarData
  ]);

  return (
    <>
      {(base64AvatarData) ? (
        <StyledAvatar
          className={className}
          disabled={disabled}
          src={base64AvatarData}
        >
          {
            !base64AvatarData
            && isLoadingAvatar
            && !errorLoadingAvatar
            && <LoadingProgress disableShrink />
          }
        </StyledAvatar>
      ) : (
        <Avatar className={className} />
      )}
    </>
  );
}
